module.exports = __webpack_public_path__ + "static/fonts/Lora-Bold.ed10af28.ttf";